import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from '@app/core/services/maintenance/maintenance.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
  selector: 'ap-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.css'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
  providers: [DatePipe]
})
export class MaintenanceBannerComponent implements OnInit {
  from: Date = null;
  to: Date = null;
  message: string = '';
  formattedMessage: string = '';

  constructor(
    private maintenanceService: MaintenanceService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    const config = this.maintenanceService.getMaintenanceConfig();
    if (config) {
      this.from = config.from ? new Date(config.from) : null;
      this.to = config.to ? new Date(config.to) : null;
      this.message = config.banner?.message || '';

      let msg = this.message;
      if (this.from) {
        const fromStr = this.datePipe.transform(this.from, 'dd/MM/yyyy HH:mm');
        msg = msg.replace('{{from}}', `<b>${fromStr}</b>`);
      }
      if (this.to) {
        const toStr = this.datePipe.transform(this.to, 'dd/MM/yyyy HH:mm');
        msg = msg.replace('{{to}}', `<b>${toStr}</b>`);
      }
      this.formattedMessage = msg;
    }
  }
}
